<template>
	<div>
		<h1>Kein Mandant ausgewählt!</h1>
		Diese Seite steht nur zur Verfügung, wenn ein Mandant ausgewählt wurde.
	</div>
</template>

<script>
  export default {
    components: {},
	data() {
		return {}
	},
    methods: {
    }
  }
</script>

<style scoped="">
</style>
